var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0503 4.27081C12.9565 2.37639 10.222 2.3764 9.12825 4.27082L2.23474 16.2101C1.14094 18.1046 2.5082 20.4726 4.69578 20.4726H18.4828C20.6704 20.4726 22.0376 18.1046 20.9438 16.2101L14.0503 4.27081ZM10.4537 5.03605C10.9584 4.16193 12.2202 4.16193 12.7249 5.03605L19.6184 16.9754C20.1231 17.8495 19.4922 18.9421 18.4828 18.9421H4.69578C3.68637 18.9421 3.05552 17.8495 3.56021 16.9754L10.4537 5.03605Z",
    fill: "#FF771D",
    stroke: "#FF771D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6676 9.13631C12.6676 8.72798 12.3111 8.41836 11.8989 8.41836C11.4868 8.41836 11.1303 8.72798 11.1303 9.13631L11.1303 12.3311C11.1303 12.7394 11.4867 13.049 11.8989 13.049C12.3111 13.049 12.6676 12.7394 12.6676 12.3311L12.6676 9.13631Z",
    fill: "#FF771D",
    stroke: "#FF771D",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6676 15.3939C12.6676 14.9624 12.3282 14.6039 11.8989 14.6039C11.4697 14.6039 11.1303 14.9624 11.1303 15.3939L11.1303 15.9699C11.1303 16.4014 11.4697 16.7599 11.8989 16.7599C12.3282 16.7599 12.6676 16.4014 12.6676 15.9699L12.6676 15.3939Z",
    fill: "#FF771D",
    stroke: "#FF771D",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.2d0f9a943d996402de3869c8722c4471.svg";
export { ForwardRef as ReactComponent };